import {Errors} from './errors';
import {ClientUser, Roles, Sex} from './user';
import {Message, ToType} from './message';
import {BanReasonData, RoomBanReasonData, RoomCloseReasonData} from "./bans";
import {LocalModeratorPermissions, ServerRoom, ServerRoomWithMembers, ServerRoomWithMembersClass} from "./room";
import {ClientSettingsModel} from "./client.settings";
import {BaseCommandMessage, BaseResponseMessage, ErrorResponseMessage} from "./commands/base";

export const COMMAND_PING = 'ping';
export const COMMAND_GET_ANNOUNCEMENT = 'command_get_announcement';
export const COMMAND_SUBSCRIBE = 'command_subscribe';
export const COMMAND_UNSUBSCRIBE = 'command_unsubscribe';
export const COMMAND_BLOCK_USER = 'block_user';
export const COMMAND_GET_CHATS = 'get_chats';
export const COMMAND_USER_CONNECTED_OR_DISCONNECTED = 'user_connected_or_disconnected';
export const COMMAND_CREATE_ROOM = 'create_chat';
export const COMMAND_GET_MESSAGES = 'get_messages';
export const COMMAND_BAN_ROOM = 'command_ban_room';
export const COMMAND_REMOVE_MESSAGES = 'remove_messages';
export const COMMAND_ADD_WORD_TO_BLACKLIST = 'command_add_word_to_blacklist';
export const COMMAND_GET_BAN_REASONS = 'command_get_ban_reasons'
export const COMMAND_ASSIGN_GLOBAL_MODERATOR = 'command_assign_global_moderator'
export const COMMAND_TAKE_OFF_GLOBAL_MODERATOR_ROLE = 'command_take_off_global_moderator_role'
export const COMMAND_SHOW_WARNING = 'show_warning';
export const COMMAND_COMPLAINT = 'complaint';
export const COMMAND_SAVE_CLIENT_SETTINGS = 'command_save_client_settings';
export const COMMAND_CHANGE_PASSWORD = 'command_change_password';
export const COMMAND_CHANGE_GENDER = 'command_change_gender';
export const COMMAND_DELETE_ACCOUNT = 'command_delete_account';
export const COMMAND_CANCEL_DELETE_ACCOUNT = 'command_cancel_delete_account';
export const COMMAND_KICK_FROM_ROOM = 'command_kick_from_room';
export const COMMAND_USER_KICKED_FROM_ROOM = 'command_user_kicked_from_room';
export const COMMAND_GRANT_PAID_ROOM_MODERATOR_ROLE = 'command_grant_paid_room_moderator_role';
export const COMMAND_TAKE_OFF_PAID_ROOM_MODERATOR_ROLE = 'command_take_off_paid_room_moderator_role';
export const COMMAND_UPDATE_ROOM_PINNED_MESSAGE = 'command_update_room_pinned_message';
export const COMMAND_UPDATE_ROOM = 'command_update_room';
export const COMMAND_CHANGE_ROOM_PASSWORD = 'command_change_room_password';
export const COMMAND_UNBLOCK_FOR_PAID_ROOM = 'command_unblock_for_paid_room';
export const COMMAND_BLOCKED_USERS = 'command_blocked_users';
export const COMMAND_MODERATORS_LIST = 'command_moderators_list';
export const COMMAND_CHANGE_MODERATOR_PERMISSIONS = 'command_change_moderator_permissions';
export const COMMAND_EDIT_ROOM_BAN_REASON = 'command_edit_room_ban_reason';
export const COMMAND_DELETE_ROOM_BAN_REASON = 'command_delete_room_ban_reason';
export const COMMAND_ROOM_BAN_REASONS = 'command_room_ban_reasons';
export const COMMAND_CLOSE_ROOM = 'command_close_room';

//Команды для администраторов
export const COMMAND_ADMINISTRATOR_SEARCH_USER = 'command_administrator_search_user'
export const COMMAND_ADMINISTRATOR_ADD_TELEGRAM_USER_TO_BLOCK = 'command_administrator_add_telegram_user_to_block'
export const COMMAND_ADMINISTRATOR_UNBLOCK_USER = 'command_administrator_unblock_user'


export * from "./commands/base";

export namespace GetChatsCommandNamespace {
    export class Response extends BaseResponseMessage {
        constructor(override readonly id: number, readonly chats: Array<ServerRoomWithMembers>) {
            super(COMMAND_GET_CHATS, id, true);
        }
    }
}

export namespace GetAnnouncementNamespace {
    export class GetAnnouncementMessage extends BaseCommandMessage {
        constructor() {
            super(COMMAND_GET_ANNOUNCEMENT);
        }
    }

    export class Response extends BaseResponseMessage {
        constructor(override readonly id: number, readonly announcement: {
            title: string,
            html: string
        }) {
            super(COMMAND_GET_ANNOUNCEMENT, id, true);
        }
    }
}

/**
 * Эта команда также означает что нужно добавить пользователя в чат
 */
export namespace SubscribeOnChatNamespace {

    export class SubscribeMessage extends BaseCommandMessage {
        constructor(readonly chat: string, readonly password: string) {
            super(COMMAND_SUBSCRIBE);
        }
    }

    export class UnsubscribeMessage extends BaseCommandMessage {
        constructor(readonly chat: string) {
            super(COMMAND_UNSUBSCRIBE);
        }
    }

    export class SubscribeResponse extends BaseResponseMessage {
        constructor(override readonly id: number, readonly chat: string, readonly user: ClientUser) {
            super(COMMAND_SUBSCRIBE, id, true);
        }
    }

    export class UnsubscribeResponse extends BaseResponseMessage {
        constructor(override readonly id: number, readonly room: string, readonly user: ClientUser) {
            super(COMMAND_UNSUBSCRIBE, id, true);
        }
    }

    export class SubscribeErrorResponse extends ErrorResponseMessage {
        constructor(override readonly id: number, error: Errors, readonly room: string) {
            super(COMMAND_SUBSCRIBE, id, error);
        }
    }

    export class KickedErrorResponse extends ErrorResponseMessage {
        constructor(override readonly id: number, readonly room: string, readonly toUnblock: number) {
            super(COMMAND_SUBSCRIBE, id, Errors.KICKED_FROM_ROOM);
        }
    }
}

export namespace UserConnectedOrDisconnectedCommandNamespace {
    export class Response extends BaseResponseMessage {
        constructor(override readonly id: number, readonly user: ClientUser, readonly isConnected: boolean) {
            super(COMMAND_USER_CONNECTED_OR_DISCONNECTED, id, true);
        }
    }
}

export namespace UserBlockingCommandNamespace {

    export enum BlockResult {
        notFound,
        userIsBot,
        userIsAdmin,
        wrongReason,
        dontHavePermissionToBlock,
        userAlreadyWarned,
        warned,
        blocked,
    }

    export class BlockMessage extends BaseCommandMessage {
        /**
         * Блокировка юзера
         * @param login логин, кого нужно заблокировать
         * @param data причина блокировки
         */
        constructor(readonly login: string, readonly data: BanReasonData) {
            super(COMMAND_BLOCK_USER);
        }
    }

    export class Response extends BaseResponseMessage {
        constructor(override readonly id: number, override readonly success: boolean, readonly user: string, readonly result: BlockResult) {
            super(COMMAND_BLOCK_USER, id, success);
        }
    }
}

export namespace ComplaintNamespace {
    export enum Complaint {
        child_porn = 'child_porn',
        spam = 'spam',
        paid_services = 'paid_services',
        man_in_woman_room = 'man_in_woman_room',
    }

    export class ComplaintMessage extends BaseCommandMessage {
        /**
         * Жалоба на пользователя
         * @param user пользователь на кого подается жалоба
         * @param message сообщение на которое пожаловались
         * @param complaint жалоба
         * @param room комната в которой была подана жалоба
         */
        constructor(readonly user: string, readonly message: string, readonly complaint: Complaint, readonly room: string) {
            super(COMMAND_COMPLAINT);
        }
    }
}

export namespace RoomsNamespace {

    export class CreateRoom extends BaseCommandMessage {

        constructor(readonly title: string, readonly password: string, readonly allowedGenders: Array<Sex>, readonly allowOnlyRegistered: boolean, readonly paid: boolean) {
            super(COMMAND_CREATE_ROOM);
        }
    }


    export class CreateRoomResponse extends BaseResponseMessage {
        constructor(override readonly id: number, readonly room: ServerRoomWithMembersClass) {
            super(COMMAND_CREATE_ROOM, id, true);
        }
    }

    export class GetMessages extends BaseCommandMessage {

        constructor(readonly title: string) {
            super(COMMAND_GET_MESSAGES);
        }
    }

    export class GetMessagesResponse extends BaseResponseMessage {
        constructor(override readonly id: number, readonly title: string, readonly messages: Array<Message>) {
            super(COMMAND_GET_MESSAGES, id, true);
        }
    }

    /**
     * Доступна только админам
     */
    export class BanRoomCommand extends BaseCommandMessage {
        constructor(readonly title: string, readonly data: RoomCloseReasonData) {
            super(COMMAND_BAN_ROOM);
        }
    }

    export class BanRoomResponse extends BaseResponseMessage {
        constructor(override readonly id: number, readonly title: string) {
            super(COMMAND_BAN_ROOM, id, true);
        }
    }

    export class CloseRoomCommand extends BaseCommandMessage {
        constructor(readonly title: string) {
            super(COMMAND_CLOSE_ROOM);
        }
    }

    export class CloseRoomSuccessResponse extends BaseResponseMessage {
        constructor(override readonly id: number, readonly title: string) {
            super(COMMAND_CLOSE_ROOM, id, true);
        }
    }

    export class UpdateRoomResponse extends BaseResponseMessage {
        constructor(override readonly id: number, readonly room: ServerRoom) {
            super(COMMAND_UPDATE_ROOM, id, true);
        }
    }
}

/**
 * Установка, смена и снятие пароля платной комнаты без её пересоздания.
 */
export namespace ChangeRoomPasswordNamespace {

    export class ChangeRoomPasswordCommand extends BaseCommandMessage {
        /**
         * @param password пустая строка означает снятие пароля
         */
        constructor(readonly room: string, readonly password: string) {
            super(COMMAND_CHANGE_ROOM_PASSWORD);
        }
    }

    export class Response extends BaseResponseMessage {
        constructor(override readonly id: number, readonly room: string, readonly hasPassword: boolean) {
            super(COMMAND_CHANGE_ROOM_PASSWORD, id, true);
        }
    }
}

export namespace RemoveMessageNamespace {
    export class RemoveMessageCommand extends BaseCommandMessage {
        constructor(readonly chat: string, readonly messagesId: Array<string>) {
            super(COMMAND_REMOVE_MESSAGES);
        }
    }

    export class RemoveMessagesResponse extends BaseResponseMessage {
        constructor(override readonly id: number, readonly chat: string, readonly messagesId: Array<string>) {
            super(COMMAND_REMOVE_MESSAGES, id, true);
        }
    }
}

export namespace BlackListNamespace {
    export class AddWordToBlackListCommand extends BaseCommandMessage {

        constructor(readonly word: string, readonly comment?: string) {
            super(COMMAND_ADD_WORD_TO_BLACKLIST);
        }
    }
}

export namespace GetBanReasons {
    export class GetBanReasonsCommand extends BaseCommandMessage {
        constructor() {
            super(COMMAND_GET_BAN_REASONS);
        }
    }

    export class GetBanReasonsResponse extends BaseResponseMessage {
        constructor(override readonly id: number, readonly usersBanReasons: Array<BanReasonData>, readonly roomBanReasons: Array<RoomCloseReasonData>) {
            super(COMMAND_GET_BAN_REASONS, id, true);
        }
    }
}

export namespace ShowWarningNamespace {
    export class ShowWarningResponse extends BaseResponseMessage {
        constructor(override readonly id: number, readonly text: string) {
            super(COMMAND_SHOW_WARNING, id, true);
        }
    }
}

export namespace AdministratorCommandsNamespace {
    export class SearchUserCommand extends BaseCommandMessage {
        constructor(readonly login: string) {
            super(COMMAND_ADMINISTRATOR_SEARCH_USER);
        }
    }

    export class UnblockUserCommand extends BaseCommandMessage {
        constructor(readonly login: string) {
            super(COMMAND_ADMINISTRATOR_UNBLOCK_USER);
        }
    }

    export class UnblockUserResponse extends BaseResponseMessage {
        constructor(override readonly id: number, override readonly success: boolean) {
            super(COMMAND_ADMINISTRATOR_UNBLOCK_USER, id, success);
        }
    }

    export class AddTelegramUsernameToBlockCommand extends BaseCommandMessage {
        constructor(readonly username: string) {
            super(COMMAND_ADMINISTRATOR_ADD_TELEGRAM_USER_TO_BLOCK);
        }
    }

    export class AddTelegramUsernameToBlockResponse extends BaseResponseMessage {
        constructor(override readonly id: number, override readonly success: boolean) {
            super(COMMAND_ADMINISTRATOR_ADD_TELEGRAM_USER_TO_BLOCK, id, success);
        }
    }

    export class AssignGlobalModeratorCommand extends BaseCommandMessage {
        constructor(readonly login: string) {
            super(COMMAND_ASSIGN_GLOBAL_MODERATOR);
        }
    }

    export class AssignGlobalModeratorResponse extends BaseResponseMessage {
        constructor(override readonly id: number) {
            super(COMMAND_ASSIGN_GLOBAL_MODERATOR, id, true);
        }
    }

    export class TakeOffGlobalModeratorRoleCommand extends BaseCommandMessage {
        constructor(readonly login: string) {
            super(COMMAND_TAKE_OFF_GLOBAL_MODERATOR_ROLE);
        }
    }

    export class TakeOffGlobalModeratorRoleResponse extends BaseResponseMessage {
        constructor(override readonly id: number) {
            super(COMMAND_TAKE_OFF_GLOBAL_MODERATOR_ROLE, id, true);
        }
    }

}

export namespace UserSettingsNamespace {
    export class SaveClientSettingsCommand extends BaseCommandMessage {
        constructor(readonly settings: ClientSettingsModel) {
            super(COMMAND_SAVE_CLIENT_SETTINGS);
        }
    }

    export class SaveClientSettingsResponse extends BaseResponseMessage {
        constructor(override readonly id: number,) {
            super(COMMAND_SAVE_CLIENT_SETTINGS, id, true);
        }
    }

    export class ChangePasswordCommand extends BaseCommandMessage {

        constructor(readonly oldPassword: string, readonly newPassword: string) {
            super(COMMAND_CHANGE_PASSWORD);
        }
    }

    export class ChangePasswordResponse extends BaseResponseMessage {
        constructor(override readonly id: number) {
            super(COMMAND_CHANGE_PASSWORD, id, true);
        }
    }

    export class ChangeGanderCommand extends BaseCommandMessage {
        constructor(readonly sex: Sex) {
            super(COMMAND_CHANGE_GENDER);
        }
    }

    export class ChangeGenderResponse extends BaseResponseMessage {
        constructor(override readonly id: number) {
            super(COMMAND_CHANGE_GENDER, id, true);
        }
    }
}

export namespace DeleteAccountNamespace {
    export class DeleteAccountCommand extends BaseCommandMessage {
        constructor() {
            super(COMMAND_DELETE_ACCOUNT);
        }
    }

    export class CancelDeleteAccountCommand extends BaseCommandMessage {
        constructor() {
            super(COMMAND_CANCEL_DELETE_ACCOUNT);
        }
    }

    export class DeleteAccountSuccessResponse extends BaseResponseMessage {
        constructor(override readonly id: number, readonly willDelete: number) {
            super(COMMAND_DELETE_ACCOUNT, id, true);
        }
    }

    export class CancelDeleteAccountSuccessResponse extends BaseResponseMessage {
        constructor(override readonly id: number) {
            super(COMMAND_CANCEL_DELETE_ACCOUNT, id, true);
        }
    }
}

export namespace RoomAdministration {
    export class KickFromRoomCommand extends BaseCommandMessage {
        /**
         *
         * @param room
         * @param login
         * @param reasonId
         * @param howLong время бана в часах
         */
        constructor(readonly room: string, readonly login: string, readonly reasonId: string, readonly howLong: number) {
            super(COMMAND_KICK_FROM_ROOM);
        }
    }

    export class KickFromRoomModeratorResponse extends BaseResponseMessage {
        constructor(override readonly id: number) {
            super(COMMAND_KICK_FROM_ROOM, id, true);
        }
    }

    export class KickFromRoomUserResponse extends BaseResponseMessage {
        constructor(override readonly id: number, readonly room: string) {
            super(COMMAND_USER_KICKED_FROM_ROOM, id, true);
        }
    }

    export class GrantPaidRoomModeratorRoleCommand extends BaseCommandMessage {
        constructor(readonly room: string, readonly login: string) {
            super(COMMAND_GRANT_PAID_ROOM_MODERATOR_ROLE);
        }
    }

    export class GrantPaidRoomModeratorRoleResponse extends BaseResponseMessage {
        constructor(override readonly id: number) {
            super(COMMAND_GRANT_PAID_ROOM_MODERATOR_ROLE, id, true);
        }
    }

    export class TakeOffRoomModeratorRoleCommand extends BaseCommandMessage {
        constructor(readonly room: string, readonly login: string) {
            super(COMMAND_TAKE_OFF_PAID_ROOM_MODERATOR_ROLE);
        }
    }

    export class TakeOffRoomModeratorRoleResponse extends BaseResponseMessage {
        constructor(override readonly id: number) {
            super(COMMAND_TAKE_OFF_PAID_ROOM_MODERATOR_ROLE, id, true);
        }
    }

    export class UpdateRoomPinnedMessage extends BaseCommandMessage {
        constructor(readonly room: string, readonly message: string) {
            super(COMMAND_UPDATE_ROOM_PINNED_MESSAGE);
        }
    }

    export class UpdateRoomPinnedResponse extends BaseResponseMessage {
        constructor(override readonly id: number) {
            super(COMMAND_UPDATE_ROOM_PINNED_MESSAGE, id, true);
        }
    }

    export class UnblockUserForPaidRoomCommand extends BaseCommandMessage {
        constructor(readonly login: string, readonly room: string) {
            super(COMMAND_UNBLOCK_FOR_PAID_ROOM);
        }
    }

    export class UnblockUserForPaidRoomResponse extends BaseResponseMessage {
        constructor(override readonly id: number, override readonly success: boolean) {
            super(COMMAND_UNBLOCK_FOR_PAID_ROOM, id, success);
        }
    }

    export class BlockedUsersCommand extends BaseCommandMessage {
        constructor(readonly room: string) {
            super(COMMAND_BLOCKED_USERS);
        }
    }

    export class BlockedUsersResponse extends BaseResponseMessage {
        constructor(override readonly id: number, readonly users: Array<BlockedUser>) {
            super(COMMAND_BLOCKED_USERS, id, true);
        }
    }

    export class BlockedUser {
        constructor(readonly moderator: string, readonly user: string, readonly message: string, readonly willUnblock: number) {
        }
    }

    export class ModeratorsListCommand extends BaseCommandMessage {
        constructor(readonly room: string) {
            super(COMMAND_MODERATORS_LIST);
        }
    }

    export interface InfoForModeratorsListCommand {
        login: string,
        permissions: Array<LocalModeratorPermissions | Roles>,
    }

    export class ModeratorsListResponse extends BaseResponseMessage {
        constructor(override readonly id: number, readonly moderators: Array<InfoForModeratorsListCommand>) {
            super(COMMAND_MODERATORS_LIST, id, true);
        }
    }

    export class ChangeModeratorPermissionsCommand extends BaseCommandMessage {
        constructor(readonly room: string, readonly moderator: string, readonly permissions: Array<LocalModeratorPermissions | Roles>,) {
            super(COMMAND_CHANGE_MODERATOR_PERMISSIONS);
        }
    }

    export class ChangeModeratorPermissionsResponse extends BaseResponseMessage {
        constructor(override readonly id: number, readonly info: InfoForModeratorsListCommand) {
            super(COMMAND_CHANGE_MODERATOR_PERMISSIONS, id, true);
        }
    }

    export class EditRoomBanReasonCommand extends BaseCommandMessage {
        constructor(readonly room: string, readonly banReason: RoomBanReasonData) {
            super(COMMAND_EDIT_ROOM_BAN_REASON);
        }
    }

    export class EditRoomBanReasonResponse extends BaseResponseMessage {
        constructor(override readonly id: number, readonly banReason: RoomBanReasonData) {
            super(COMMAND_EDIT_ROOM_BAN_REASON, id, true);
        }
    }

    export class RoomBanReasonsCommand extends BaseCommandMessage {
        constructor(readonly room: string) {
            super(COMMAND_ROOM_BAN_REASONS);
        }
    }

    export class RoomBanReasonsResponse extends BaseResponseMessage {
        constructor(override readonly id: number, readonly data: Array<RoomBanReasonData>) {
            super(COMMAND_ROOM_BAN_REASONS, id, true);
        }
    }

    export class DeleteRoomBanReasonCommand extends BaseCommandMessage {
        constructor(readonly room: string, readonly reasonId: string) {
            super(COMMAND_DELETE_ROOM_BAN_REASON);
        }
    }

    export class DeleteRoomBanReasonResponse extends BaseResponseMessage {
        constructor(override readonly id: number) {
            super(COMMAND_DELETE_ROOM_BAN_REASON, id, true);
        }
    }

}

export * from './commands/buy-premium';
export * from './commands/user-data-updated';
export * from './commands/send-to';
